import React from 'react';
import { IconButton } from '@mui/material';
import { AMFModalContent } from './content';
import { Icon, SimpleModal } from '@livable/saas-react-components';
export const AMFModal = _ref => {
  let defaultAdminFee = _ref.defaultAdminFee,
    adminFee = _ref.adminFee,
    residencyId = _ref.residencyId;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noHeader: true,
    noPadding: true,
    trigger: /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    })),
    variant: 'small'
  }, /*#__PURE__*/React.createElement(AMFModalContent, {
    defaultAdminFee: defaultAdminFee,
    adminFee: adminFee,
    residencyId: residencyId
  }));
};